import { useState } from "react";
import { Table } from "../../../components/shared";
import useSearchAndFilter from "../../../hooks/useSearchAndFilter";
import FilterSideMenu from "../../../components/shared/FilterSideMenu";
import {  FilterIcon, FilterIconWhite } from "../../../assets";
import { Badge } from "@mui/material";
import { Loader } from "../../../components/loaders/loaders";
import { columns } from "./OrderStatusTypes";
import AddEditOrderStatusModal from "./components/AddEditOrderStatus";
import {  GET_STATUS_ENDPOINT } from "../../../apis/end-points";
import { DEFAULT_PAGE_SIZE } from "../../../utils/constants";

const OrderStatusListing = () => {
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isOrderStatusModalOpen, setIsOrderStatusModalOpen] =
    useState<boolean>(false);
  const [selectedOrderStatus, setSelectedOrderStatus] = useState<any>({});

  const {
    data,
    loading,
    setLoading,
    closeOpenfilterModal,
    isShowFilterModal,
    serviceName,
    setServiceName,
    fetchFilteredData,
    fetchWithCurrentFilters,
    captureAppliedFilters,
    filterApplied,
    setFilterApplied,
    onwardService,
    setOnwardService,
    clearCurrentFilters,
  } = useSearchAndFilter<any>({
    apiUrl: GET_STATUS_ENDPOINT,
    limit: DEFAULT_PAGE_SIZE,
    mapUserData: (data: any[]) =>
    data.map((item) => ({
      ...item,
      onwardStatusName:
        item.onwardStatusName && item.onwardStatusName.trim() !== ""
          ? item.onwardStatusName
          : "--",
    })),
    screenKey: "orderStatus",
  });

  const handleCloseModal = () => {
    setIsOrderStatusModalOpen(false);
  };

  const handleEdit = (rowData: any) => {
    setIsOrderStatusModalOpen(true);
    setIsEdit(true);
    setSelectedOrderStatus(rowData);
  };

  if (loading) return <Loader />;

  if (isOrderStatusModalOpen) {
    return (
      <AddEditOrderStatusModal
        isEdit={isEdit}
        isOpen={isOrderStatusModalOpen}
        onClose={handleCloseModal}
        initialData={isEdit ? selectedOrderStatus : null}
        onSuccess={fetchWithCurrentFilters}
      />
    );
  }

  return (
    <div
      className={`tableWrap ${
        isShowFilterModal ? "tableWrap--filterOpen" : ""
      }`}
    >
      <div className="tableWrap__head tableWrap__head--end">
        <div className="btn__group formRow--flexEnd">
          {filterApplied ? (
            <Badge badgeContent=" " color="primary">
              <button
                className={
                  !isShowFilterModal ? "btn btn__white" : "btn btn__primary"
                }
                onClick={closeOpenfilterModal}
              >
                {!isShowFilterModal ? <FilterIcon /> : <FilterIconWhite />}
                Filter
              </button>
            </Badge>
          ) : (
            <button
              className={
                !isShowFilterModal ? "btn btn__white" : "btn btn__primary"
              }
              onClick={closeOpenfilterModal}
            >
              {!isShowFilterModal ? <FilterIcon /> : <FilterIconWhite />}
              Filter
            </button>
          )}

          <FilterSideMenu
            isShowFilterModal={isShowFilterModal}
            closeOpenfilterModal={closeOpenfilterModal}
            serviceName={serviceName}
            setServiceName={setServiceName}
            isHubHide={true}
            isOrderTypeHide={true}
            isOrderStatusHide={true}
            isStatusHide={true}
            showServiceName={true}
            isRoleHide={true}
            isServiceHide={true}
            showCustomerName={false}
            showAgentName={false}
            isAllCustomerTypeHide={true}
            isAgentTypeHide={true}
            fetchFilteredData={fetchFilteredData}
            onFiltersApplied={captureAppliedFilters}
            filterApplied={filterApplied}
            setFilterApplied={setFilterApplied}
            showonwardService={true}
            onwardService={onwardService}
            setOnwardService={setOnwardService}
            table="OrderStatusListingTable"
            clearFiltersFromStorage={clearCurrentFilters}
          />
        </div>
      </div>

      <Table
        table="orderStatusList"
        columns={columns}
        setLoading={setLoading}
        data={data}
        getApiData={fetchWithCurrentFilters}
        editIcon={true}
        manageIcon={false}
        onEditNaviagte={{
          apiUrl: "",
          urlID: "id",
          onClick: handleEdit,
          isEditWithoutLink: true,
        }}
        deleteIcon={false}   
      />
    </div>
  );
};

export default OrderStatusListing;
